module.exports = __webpack_public_path__ + "static/media/p2p.270ef6e5.svg";